(ns common.resource.query.adset-activation
  (:require [cljs-bean.core :refer [->clj ->js]]
            [common.queries :as queries :refer [invalidate-queries]]
            [common.queries.http :as qhttp]
            [common.queries.muix-filter-util :as filter-util]
            [mate.core :as mc]
            [re-frame.core :as rf]))

(def max-fetch-count 10)
(def max-fetch-interval (* 10 1000))

(def adset-activation-query-refetch
  (queries/make-refetch-interval-fn
   {:interval-fn (fn [^js _query fetch-count]
                   ;; TODO introduce logic for early fetch stopping
                   (if (< fetch-count max-fetch-count)
                     (* (queries/sigmoid (- fetch-count 2)) max-fetch-interval)
                     0))}))

(defn adset-activation-query
  [{:keys [advertiser-id adset-id] :as context}
   filter-params
   {:keys [^js sort-model ^js filter-model ^js pagination-model] :as table-models}]
  #js {:enabled (some? adset-id)
       :queryKey #js ["adset-activation" advertiser-id adset-id
                      (.-pageSize pagination-model) sort-model filter-model]
       :queryFn
       (fn [^js ctx]
         (let [{:keys [muix-data-grid] :as query-params}
               (filter-util/get-query-params filter-params table-models ctx)]
           (qhttp/post (qhttp/render :api/content-build-adset-activations-search
                                     context
                                     (dissoc query-params :muix-data-grid))
                       {:body {:muix-data-grid muix-data-grid}})))
       :getNextPageParam (fn [lastPage _pages]
                           (-> lastPage ->clj :data last :cursor))
       :staleTime (* 60 1000)
       :refetchInterval adset-activation-query-refetch})

(defn transform-tiktok-adset-activation-rows [response]
  (let [{:keys [total data]} (->clj response)]
    (->js
     {:total total
      :data
      (for [[group-id {{:keys [tiktok-activations]} :data
                       :as activation-row}] (mc/seq-indexed data)
            tiktok-activation (sort-by :ad-type tiktok-activations)]
        (-> activation-row
            (update :data dissoc :tiktok-activations)
            (assoc-in [:data :data] tiktok-activation)
            (assoc-in [:data :group-id] group-id)))})))

(defn adset-tiktok-activation-query
  [{:keys [advertiser-id adset-id] :as context}
   filter-params
   {:keys [^js sort-model ^js filter-model ^js pagination-model] :as table-models}]
  #js {:enabled (some? adset-id)
       :queryKey #js ["tiktok-adset-activation" advertiser-id adset-id
                      (.-pageSize pagination-model) sort-model filter-model]
       :queryFn
       (fn [^js ctx]
         (let [{:keys [muix-data-grid] :as query-params}
               (filter-util/get-query-params filter-params table-models ctx)]
           (-> (qhttp/post (qhttp/render :api/content-build-adset-tiktok-activations-search-by-content-id
                                         context
                                         (dissoc query-params :muix-data-grid))
                           {:body {:muix-data-grid muix-data-grid}})
               (.then transform-tiktok-adset-activation-rows))))
       :getNextPageParam (fn [lastPage _pages]
                           (-> lastPage ->clj :data last :cursor))
       :staleTime (* 60 1000)
       :refetchInterval adset-activation-query-refetch})

(defn adset-activation-by-content-id-query
  [{:keys [advertiser-id adset-id] :as context}
   filter-params
   {:keys [^js sort-model ^js filter-model ^js pagination-model] :as table-models}]
  #js {:enabled (some? adset-id)
       :queryKey #js ["adset-activation" advertiser-id adset-id "by-content-id"
                      (.-pageSize pagination-model) sort-model filter-model]
       :queryFn (fn [^js ctx]
                  (let [{:keys [muix-data-grid] :as query-params}
                        (filter-util/get-query-params
                         (assoc filter-params
                                :default-sorting {:field "content-id>"
                                                  :sort "asc"})
                         table-models ctx)]
                    (->
                     (qhttp/post (qhttp/render
                                  :api/content-build-adset-activations-search-by-content-id
                                  context
                                  (dissoc query-params :muix-data-grid))
                                 {:body {:muix-data-grid muix-data-grid}})
                     (.then (fn [response]
                              (let [{:keys [total data]} (->clj response)]
                                (-> {:total total
                                     :data (for [{cursor :cursor
                                                  {:keys [dv-activations]} :data} data
                                                 dv-activation dv-activations]
                                             {:data dv-activation
                                              :cursor cursor})}
                                    ->js)))))))
       :getNextPageParam (fn [lastPage _pages]
                           (-> lastPage ->clj :data last :cursor))
       :staleTime (* 60 1000)
       :refetchInterval adset-activation-query-refetch})

(defn adset-activations-query
  [{:keys [advertiser-id adset-id] :as context}
   filter-params
   {:keys [^js sort-model ^js filter-model ^js pagination-model] :as table-models}]
  #js {:enabled (some? adset-id)
       :queryKey #js ["adset-activation" advertiser-id adset-id "by-content-id"
                      (.-pageSize pagination-model) sort-model filter-model]
       :queryFn (fn [^js ctx]
                  (let [{:keys [muix-data-grid] :as query-params}
                        (filter-util/get-query-params filter-params table-models ctx)]
                    (qhttp/post (qhttp/render
                                 :api/content-build-adset-dv-activations-search
                                 context
                                 (dissoc query-params :muix-data-grid))
                                {:body {:muix-data-grid muix-data-grid}})))
       :getNextPageParam (fn [lastPage _pages]
                           (-> lastPage ->clj :data last :cursor))
       :staleTime (* 60 1000)
       :refetchInterval adset-activation-query-refetch})

(defn activation-log-query [{:keys [advertiser-id adset-id enabled] :as url-context
                             :or {enabled true}}]
  #js {:enabled (and enabled (some? adset-id))
       :queryKey #js ["activation-log" advertiser-id adset-id]
       :retry queries/prevent-client-error-retries
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/content-build-adset-activation-log url-context)))})

(defn adset-activation-schedule-query [{:keys [advertiser-id adset-id enabled]
                                        :or {enabled true}}]
  #js {:enabled (and enabled (some? adset-id))
       :queryKey #js ["fetch-adset-activation-schedule" advertiser-id adset-id]
       :retry queries/prevent-client-error-retries
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/content-build-adset-activation-schedule
                                           {:advertiser-id advertiser-id
                                            :adset-id adset-id})))})

(defn adset-activation-schedule-mutation [{:keys [advertiser-id adset-id]}]
  #js {:mutationKey #js ["modify-adset-activation-schedule" advertiser-id adset-id]
       :mutationFn (fn [{:keys [paused]}]
                     (qhttp/put (qhttp/render :api/content-build-adset-activation-schedule
                                              {:advertiser-id advertiser-id
                                               :adset-id adset-id})
                                {:body {:paused paused}}))
       :onSuccess (fn [response {:keys [paused]}]
                    (.setQueryData
                     queries/query-client
                     #js ["fetch-adset-activation-schedule" advertiser-id adset-id]
                     response)
                    (rf/dispatch [:response-handler/handle-response
                                  {:entity-name "Activation schedule"
                                   :type :success
                                   :message (str "Sync "
                                                 (if paused
                                                   "Paused"
                                                   "Resumed"))
                                   :full-message (when paused
                                                   "Meta sync has been paused. Ad delivery and status updates will not be evaluated or sent. Publishing new tree versions will not re-activate syncing — you must resume it manually when ready.")}]))})

(defn update-activation-mutation
  [{:keys [advertiser-id adset-id activation-id] :as context}]
  #js {:mutationKey #js ["update-activation" advertiser-id adset-id activation-id]
       :mutationFn (fn [params]
                     (rf/dispatch [:loader/open])
                     (qhttp/put (qhttp/render :api/content-build-adset-activation
                                              context)
                                {:body params}))
       :onSuccess (fn [_response]
                    (invalidate-queries {:queryKey ["adset-activation" advertiser-id adset-id]})
                    (invalidate-queries {:queryKey ["tiktok-adset-activation" advertiser-id adset-id]}))
       :onSettled #(rf/dispatch [:loader/close])})
